import { Component } from '@angular/core';
import { AssetsService } from '@shared/services/assets.service';

@Component({
    selector: 'sr-login-app-root',
    template: '<router-outlet></router-outlet>',
    styleUrls: ['./login-app.component.scss'],
    standalone: false,
})
export class LoginAppComponent {
    constructor(private _assets: AssetsService) {
        this._assets.useMdiIcons();
    }
}